import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Box from '@material-ui/core/Box';
import DataGridPreview from '@afosto/app-components-react/DataGrid/DataGridPreview';
import LoadingWrapper from '@afosto/components-react/LoadingWrapper';
import Property from '@afosto/app-components-react/Property';
import capitalize from '@afosto/utils/string/capitalize';
import translations from './translations';

const ChannelPreview = ({ channel, isLoading, isOpen, menu, onClose }) => {
  const intl = useIntl();

  return (
    <DataGridPreview title={channel?.name} menu={menu} open={isOpen} onClose={onClose}>
      <LoadingWrapper isLoading={isLoading}>
        <Box px={2}>
          <Property
            label={intl.formatMessage(translations.properties.name)}
            value={channel?.name}
          />
          <Property
            label={intl.formatMessage(translations.properties.description)}
            value={channel?.description}
          />
          <Property
            label={intl.formatMessage(translations.properties.type)}
            value={intl.formatMessage({
              id: `channelTypes.${channel?.type}`,
              defaultMessage: capitalize(channel?.type ?? ''),
              description: `Label for channel type ${channel?.type}`,
            })}
          />
          <Property
            label={intl.formatMessage(translations.properties.client)}
            value={channel?.client?.name}
          />
        </Box>
      </LoadingWrapper>
    </DataGridPreview>
  );
};

ChannelPreview.propTypes = {
  channel: PropTypes.object,
  isLoading: PropTypes.bool,
  isOpen: PropTypes.bool,
  menu: PropTypes.array,
  onClose: PropTypes.func,
};

ChannelPreview.defaultProps = {
  channel: undefined,
  isLoading: true,
  isOpen: false,
  menu: [],
  onClose: undefined,
};

export default ChannelPreview;
